const authorizationActions = {}

authorizationActions.actionTypes = {
  REQUEST_MAGIC_LINK: '{AUTHORIZATION} Request Magic Link',
  REQUEST_MAGIC_LINK_SUCCEEDED: '{AUTHORIZATION} Request Magic Link Succeeded',
  REQUEST_MAGIC_LINK_FAILED: '{AUTHORIZATION} Request Magic Link Failed',

  VERIFY_MAGIC_LINK: '{AUTHORIZATION} Verify Magic Link',
  VERIFY_MAGIC_LINK_SUCCEEDED: '{AUTHORIZATION} Verify Magic Link Succeeded',
  VERIFY_MAGIC_LINK_FAILED: '{AUTHORIZATION} Verify Magic Link Failed',

  LOGOUT: '{AUTHORIZATION} User Logout',
  LOGOUT_SUCCEEDED: '{AUTHORIZATION} User Logout Succeeded',
  LOGOUT_FAILED: '{AUTHORIZATION} User Logout Failed',

  RESET_LOGIN_ERRORS: '{AUTHORIZATION} Reset Login Errors',
}

authorizationActions.requestMagicLink = function (email, onSuccess) {
  return {
    type: authorizationActions.actionTypes.REQUEST_MAGIC_LINK,
    payload: {
      email,
      onSuccess,
    },
  }
}

authorizationActions.requestMagicLinkSucceeded = function () {
  return {
    type: authorizationActions.actionTypes.REQUEST_MAGIC_LINK_SUCCEEDED,
  }
}

authorizationActions.requestMagicLinkFailed = function (message) {
  return {
    type: authorizationActions.actionTypes.REQUEST_MAGIC_LINK_FAILED,
    payload: {
      message,
    },
  }
}

authorizationActions.verifyMagicLink = function (token, onSuccess) {
  return {
    type: authorizationActions.actionTypes.VERIFY_MAGIC_LINK,
    payload: {
      token,
      onSuccess,
    },
  }
}

authorizationActions.verifyMagicLinkSucceeded = function (data) {
  return {
    type: authorizationActions.actionTypes.VERIFY_MAGIC_LINK_SUCCEEDED,
    payload: {
      data,
    },
  }
}

authorizationActions.verifyMagicLinkFailed = function (message) {
  return {
    type: authorizationActions.actionTypes.VERIFY_MAGIC_LINK_FAILED,
    payload: {
      message,
    },
  }
}

authorizationActions.logout = function () {
  return {
    type: authorizationActions.actionTypes.LOGOUT,
  }
}

authorizationActions.logoutSucceeded = function () {
  return {
    type: authorizationActions.actionTypes.LOGOUT_SUCCEEDED,
  }
}

authorizationActions.logoutFailed = function (message) {
  return {
    type: authorizationActions.actionTypes.LOGOUT_FAILED,
    payload: {
      message,
    },
  }
}

authorizationActions.resetLoginErrors = function () {
  return {
    type: authorizationActions.actionTypes.RESET_LOGIN_ERRORS,
  }
}

export default authorizationActions
